/* eslint-disable import/prefer-default-export */
import { Highlighter } from "react-bootstrap-typeahead";
import { IAddressProps } from "pages/shipper/RequestForm/components/Schedule/Types";

export const handleRenderAddressOption = ({ option, text }: { option: IAddressProps; text: string }) => (
  <div className="p-7">
    <div className="font-weight-bold font-12">
      <Highlighter search={text}>{`${option.code ? `(${option.code})` : ""} ${option.label ? `${option.label}` : ""} ${
        option.country_name ? `${option.country_name}` : ""
      } ${option.country_code ? `${option.country_code}` : ""} `}</Highlighter>
    </div>
  </div>
);
